module.exports = __webpack_public_path__ + "../resources/img/storebadge_fr.2cfdd0a7.svg";